import './PoweredByGoogle.scss';

const GOOGLE_LOGO = 'https://cdn.blisspointmedia.com/assets/img/Google.png';

export const PoweredByGoogle = () => (
  <div className='powered-by-google-container'>
    <div className='powered-by-google-label'>
      Powered by Google Insights Finder and Reach Planner.
    </div>
    <img src={GOOGLE_LOGO} alt='Google Logo' className='google-logo' />
  </div>
);
